module.exports = (__webpack_require__(42845))(6540);